import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Link,
  Stack
} from '@mui/material';
import {
  INCOMPLETE_SBF,
  LABELS,
  SMALL_BUSINESS_FORM
} from '../../shared/AppConstants';

export default function ReviewPublish(props) {
  const { showSaveButton, duplicateStrategyCount, isSDFError, hasSDFStep } =
    props;

  function getChecklistItem(label, inPageLink, inError, errorBadgeMsg) {
    return (
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.fuel6Tokens.JddcSpacingXSmall,
          py: theme.fuel6Tokens.JddcSpacingXXSmall
        })}
      >
        <Box
          sx={(theme) => ({
            color: inError
              ? theme.fuel6Tokens.JddcColorIconError
              : theme.fuel6Tokens.JddcColorIconSuccess
          })}
          display={'flex'}
          gap={1}
        >
          <fuel-icon name={inError ? 'close' : 'check'} />
          <Link href={`#${inPageLink}`} underline="hover" variant="bodyMedium">
            {label}
          </Link>
          {inError && errorBadgeMsg && (
            <Chip
              icon={<fuel-icon name={'error'} />}
              variant={'badge'}
              color={'error'}
              label={errorBadgeMsg}
              sx={(theme) => ({ ml: theme.fuel6Tokens.JddcSpacingSmall })}
            />
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Card
        sx={(theme) => ({
          maxWidth: 760
        })}
      >
        <CardContent>
          <Stack spacing={1}>
            {getChecklistItem(
              'Define Strategy',
              'defineSection',
              duplicateStrategyCount > 0,
              'Conflicting Strategy Exists'
            )}

            {getChecklistItem('Add Suppliers', 'supplierSection', false)}

            {hasSDFStep &&
              getChecklistItem(
                SMALL_BUSINESS_FORM,
                'sdfSection',
                isSDFError,
                INCOMPLETE_SBF
              )}
          </Stack>
        </CardContent>
      </Card>

      {showSaveButton && (
        <Stack
          direction="row"
          spacing={1.5}
          sx={(theme) => ({ mt: theme.fuel6Tokens.JddcSpacingMedium })}
        >
          <Button variant="secondary" type="submit" value="save">
            {LABELS.SAVE_DRAFT}
          </Button>
          <Button variant="primary" type="submit" value="complete">
            {LABELS.COMPLETE_SETUP}
          </Button>
        </Stack>
      )}
    </Box>
  );
}
